
import * as actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
    loading: false,
    cropObjects: {
        showMode: "none",
        showOverlay: false,
        cropImport: {},
        currentObj: {},
        cropPreview: {},
        showObj: {},
        flipObj: {},
        selfObj: {},
        currentPresets: "free",
        currentTags: "free",
        showPanel: false,
        showCropBox: false
    },
}
const CropReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.CROPIMAGE_UPDATE_CROPOBJECTS_START:
            return { loading: true };
        case actionTypes.CROPIMAGE_UPDATE_CROPOBJECTS_SUCCESS:
            return { loading: false, cropObjects: { ...state.cropObjects, ...action.payload } }
        case actionTypes.CROPIMAGE_UPDATE_CROPOBJECTS_FAIL:
            return { loading: false };
        case actionTypes.CROPIMAGE_IMPORT_CROPOBJECTS_START:
            return { ...state, loading: true }
        case actionTypes.CROPIMAGE_IMPORT_CROPOBJECTS_SUCCESS:
            return { ...state, loading: false }
        case actionTypes.CROPIMAGE_IMPORT_CROPOBJECTS_FAIL:
            return { ...state, loading: true }
        case actionTypes.CROPIMAGE_SET_LOADING:
            return { ...state, loading: action.payload };
        case actionTypes.CROPIMAGE_SET_INIT_CROPOBJECTS:
            return { ...INITIAL_STATE };
        default:
            return state;
    }
}

export default CropReducer;